import { render, staticRenderFns } from "./SubField.vue?vue&type=template&id=a057af50"
import script from "./SubField.vue?vue&type=script&lang=js"
export * from "./SubField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports